import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import { EMPLOYEE_ACCEPT_TERMS_AND_CONDITIONS, HOST, WEB_GET_POLICY_LIST } from '../../../component/config/Constant';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AuthContext } from '../../../component/context/AuthContext';

function ReadPolicies({ action }) {
  const [show, setShow] = useState(true);
  const [policies, setPolicies] = useState("");
  const [agreeAll, setAgreeAll] = useState(false); //  final checkbox
  const [error, setError] = useState(""); //  validation msg
  const [authUserData, setAuthUserData] = useContext(AuthContext);
  /*   const handleClose = () => setShow(false); */
  const handleClose = () => {
    if (action !== "not_close") {
      setShow(false);
    } else {
      toast.error("Please read all policies");
    }
  };

  let userId = 0;
  if (authUserData) {
    if (authUserData[0]) {
      userId = authUserData[0].user_id ? authUserData[0].user_id : 0;
    }
  }

  useEffect(() => {
    fetchPolicyDetails();
  }, []);

  const fetchPolicyDetails = async () => {
    await axios
      .get(WEB_GET_POLICY_LIST,
        {
          page_number: 1,
          limit: 100
        })
      .then((response) => {
        const status = response.data.status;
        if (status === 'success') {
          setPolicies(response.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function convertToSlug(Text) {
    return Text.toLowerCase()
      .replace(/[^\w ]+/g, '')
      .replace(/ +/g, '-');
  }


  async function handleSubmit() {
    if (!agreeAll) {
      toast.error("Please confirm you have read all policies and terms.");
      return;
    }
    try {

      await axios.post(EMPLOYEE_ACCEPT_TERMS_AND_CONDITIONS, {
        //accepted_terms_and_conditions: 1,
        accepted_terms_and_conditions: "1",
        user_id: userId,
      })
        .then((response) => {
          const status = response.data.status;
          console.log(response);
          if (response.data.status === "success") {
            const newToken = response.data.data && response.data.data.access_token;

            if (newToken) {
              localStorage.setItem("eToken", newToken);
              // Update context with both the new token and the accepted flag
              // Updating the token in state will trigger AuthContext's useEffect to re-decode everything
              setAuthUserData(prev =>
                prev.map(u => ({
                  ...u,
                  token: newToken,
                  accepted_terms_and_conditions: "1"
                }))
              );
            } else {
              // Fallback if no token returned (shouldn't happen with my backend change)
              setAuthUserData(prev =>
                prev.map(u => ({
                  ...u,
                  accepted_terms_and_conditions: "1"
                }))
              );
            }

            toast.success("Terms and conditions accepted successfully!");
            setShow(false);
          }
          else {
            toast.error(response.data.message);
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    }
  }
  return (
    <Modal
      size="lg"
      show={show}
      onHide={(handleClose)}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        <h6>Read Policies</h6>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-md-6 mb-3">
            <ul className='list-numbers'>
              {
                policies && policies.map((policy, index) => {
                  if (policy.e_policy_type.name === 'Textual Policies') {
                    return (
                      <li className="col-md-12 mb-2" key={policy.id}>
                        <Link
                          className="page-scroll text-decoration-underline link"
                          aria-current="page"
                          to={"/policy/" + policy.id + "/" + convertToSlug(policy.policy_name)}
                          target="_blank"
                        >
                          {policy.policy_name}
                        </Link>
                      </li>
                    );
                  }
                })
              }
            </ul>
          </div>
          <div className="col-md-6 mb-3">
            <ul className='list-numbers'>
              {
                policies && policies.map((policy, index) => {
                  if (policy.e_policy_type.name === 'Download Policies') {
                    return (
                      <li className="col-md-12 mb-2" key={policy.id}>

                        <Link
                          className="page-scroll text-decoration-underline link"
                          aria-current="page"
                          to={HOST + policy.policy_document_path}
                          target="_blank"
                        >
                          {policy.policy_name}
                        </Link>
                      </li>
                    );
                  }
                })
              }
            </ul>
          </div>
        </div>

        {/* ✅ Final agreement checkbox */}
        <div className="mt-3">
          <input
            type="checkbox"
            checked={agreeAll}
            onChange={() => setAgreeAll(!agreeAll)}
            className="m-2"
          />
          <label>I have read all policies and terms & conditions.</label>
        </div>

        {/* ✅ Validation error */}
        {error && <p className="text-danger mt-2">{error}</p>}

        {/* ✅ Submit button */}
        <div className="mt-3">
          <button className="btn btn-primary" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default ReadPolicies;
